(function () {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  const DISCOUNT_CODES = {
    bonus1: 'PS-BONUS-5',
    bonus2: 'PS-BONUS-10'
  };

  const CHECKOUT_URL = '/checkout';
  const PURCHASE_PROCESS_URL = '/pages/purchase-process';
  const FLOW_STORAGE_KEY = 'ps_cart_bonus_flow_v1';

  /*
    IMPORTANT:
    These arrays are for discount-code safety, not only display.
    Keep every product included inside each Shopify discount code here.
    This prevents Shopify from discounting a normal product-page line when the same product is already in cart.
  */
  const BONUS_1_DISCOUNT_HANDLES = [
    'protek-short-sleeve-crew-neck-midnight-blue',
    'performance-series-6-panel-classic-waterproof-golf-hat-taffy',
    'limited-stock-womens-short-sleeve-fishing-shirt-salt-white'
  ];

  const BONUS_2_DISCOUNT_HANDLES = [
    'performance-golf-shorts-graphite-gray',
    '5-panel-waterproof-non-structured-golf-hat-with-visor-rope-gulf-green'
  ];

  const drawer = document.getElementById('psCartDrawer');
  if (!drawer) return;

  const cartItemsContainer = drawer.querySelector('[data-ps-cart-items]');
  const cartCountEls = drawer.querySelectorAll('[data-ps-cart-count]');
  const footerCountEl = drawer.querySelector('[data-ps-footer-count]');
  const subtotalEl = drawer.querySelector('[data-ps-cart-subtotal]');
  const decorateError = drawer.querySelector('[data-ps-decorate-error]');
  const flowError = drawer.querySelector('[data-ps-checkout-flow-error]');
  const upsellsWrap = drawer.querySelector('[data-ps-upsells-wrap]');
  const bonus1Section = drawer.querySelector('[data-ps-bonus-section="1"]');
  const bonus2Section = drawer.querySelector('[data-ps-bonus-section="2"]');
  const checkoutButton = drawer.querySelector('[data-ps-checkout]');
  const progressBar = drawer.querySelector('[data-ps-cart-progress]');
  const bonusTabs = drawer.querySelectorAll('[data-ps-tab]');

  let lastCart = null;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function buildStorePath(path) {
    const cleanRoot = root.endsWith('/') ? root.slice(0, -1) : root;
    const cleanPath = path.startsWith('/') ? path : '/' + path;

    if (cleanRoot === '') return cleanPath;

    return cleanRoot + cleanPath;
  }

  function buildDiscountUrl(codes, redirectPath) {
    if (!codes.length) {
      return buildStorePath(redirectPath);
    }

    const codePath = codes.map(encodeURIComponent).join(',');
    const redirect = buildStorePath(redirectPath);

    return root + 'discount/' + codePath + '?redirect=' + encodeURIComponent(redirect);
  }

  function openDrawer() {
    document.body.classList.add('ps-cart-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    document.body.classList.remove('ps-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  async function getCart() {
    const res = await fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    return await res.json();
  }

  function getItemOptions(item) {
    if (!item.options_with_values || !item.options_with_values.length) return '';

    return item.options_with_values
      .filter(function (option) {
        const name = normalize(option.name);
        const value = normalize(option.value);

        if (name === 'title' && value === 'default title') return false;
        if (value === 'default title') return false;

        return true;
      })
      .map(function (option) {
        return `<span>${option.name}: ${option.value}</span>`;
      })
      .join('');
  }

  function isDrawerUpsellLine(item, tierName) {
    const properties = item.properties || {};

    if (tierName) {
      return (
        properties['_ps_upsell_source'] === 'cart_drawer' &&
        properties['_ps_bonus_tier'] === tierName
      );
    }

    return properties['_ps_upsell_source'] === 'cart_drawer';
  }

  function getOriginalCartSignature(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';

    return cart.items
      .filter(function (item) {
        return !isDrawerUpsellLine(item);
      })
      .map(function (item) {
        return [item.handle, item.variant_id].join(':');
      })
      .sort()
      .join('|');
  }

  function getSavedFlowState() {
    try {
      return JSON.parse(sessionStorage.getItem(FLOW_STORAGE_KEY) || '{}');
    } catch (err) {
      return {};
    }
  }

  function saveFlowState(state) {
    sessionStorage.setItem(FLOW_STORAGE_KEY, JSON.stringify(state));
  }

  function resetFlowState() {
    sessionStorage.removeItem(FLOW_STORAGE_KEY);
  }

  function cartHasTierUpsell(cart, tierName) {
    return Boolean(
      cart &&
      cart.items &&
      cart.items.some(function (item) {
        return isDrawerUpsellLine(item, tierName);
      })
    );
  }

  function getFlowStateForCart(cart) {
    const hasCartItems = Boolean(cart && cart.items && cart.items.length);

    if (!hasCartItems) {
      resetFlowState();
      return {
        hasCartItems: false,
        bonus1Done: false,
        bonus2Done: false
      };
    }

    const signature = getOriginalCartSignature(cart) || 'upsell-only-cart';
    let saved = getSavedFlowState();

    if (saved.signature !== signature) {
      saved = {
        signature: signature,
        bonus1Done: false,
        bonus2Done: false
      };
      saveFlowState(saved);
    }

    return {
      hasCartItems: true,
      bonus1Done: Boolean(saved.bonus1Done || cartHasTierUpsell(cart, 'Bonus 1')),
      bonus2Done: Boolean(saved.bonus2Done || cartHasTierUpsell(cart, 'Bonus 2')),
      signature: signature
    };
  }

  function completeBonusStep(step) {
    if (!lastCart || !lastCart.items || !lastCart.items.length) return;

    const signature = getOriginalCartSignature(lastCart) || 'upsell-only-cart';
    const saved = getSavedFlowState();

    const nextState = {
      signature: signature,
      bonus1Done: Boolean(saved.bonus1Done),
      bonus2Done: Boolean(saved.bonus2Done)
    };

    if (String(step) === '1') {
      nextState.bonus1Done = true;
    }

    if (String(step) === '2') {
      nextState.bonus2Done = true;
    }

    saveFlowState(nextState);
    updateFlowUI(lastCart);

    if (String(step) === '1' && bonus2Section) {
      bonus2Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function showFlowError(message) {
    if (!flowError) return;

    flowError.textContent = message;
    flowError.style.display = 'block';
  }

  function hideFlowError() {
    if (flowError) {
      flowError.style.display = 'none';
    }
  }

  function updateFlowUI(cart) {
    lastCart = cart;

    const flow = getFlowStateForCart(cart);

    drawer.classList.toggle('ps-cart-empty', !flow.hasCartItems);

    if (upsellsWrap) {
      upsellsWrap.hidden = !flow.hasCartItems;
    }

    if (bonus1Section) {
      bonus1Section.hidden = !flow.hasCartItems;
    }

    if (bonus2Section) {
      bonus2Section.hidden = !flow.hasCartItems || !flow.bonus1Done;
    }

    if (!flow.hasCartItems) {
      if (checkoutButton) {
        checkoutButton.classList.add('is-locked');
        checkoutButton.setAttribute('aria-disabled', 'true');
      }
      if (progressBar) progressBar.style.width = '0%';
      hideFlowError();
      return;
    }

    if (checkoutButton) {
      checkoutButton.classList.toggle('is-locked', !flow.bonus2Done);
      checkoutButton.setAttribute('aria-disabled', flow.bonus2Done ? 'false' : 'true');
    }

    if (progressBar) {
      if (flow.bonus2Done) {
        progressBar.style.width = '100%';
      } else if (flow.bonus1Done) {
        progressBar.style.width = '66%';
      } else {
        progressBar.style.width = '33%';
      }
    }

    bonusTabs.forEach(function (tab) {
      const tabStep = tab.getAttribute('data-ps-tab');
      tab.classList.remove('is-active', 'is-complete', 'is-locked');

      if (tabStep === '1') {
        tab.classList.add(flow.bonus1Done ? 'is-complete' : 'is-active');
      }

      if (tabStep === '2') {
        if (!flow.bonus1Done) {
          tab.classList.add('is-locked');
        } else {
          tab.classList.add(flow.bonus2Done ? 'is-complete' : 'is-active');
        }
      }
    });
  }

  function getDiscountCodesFromCart(cart) {
    let hasBonus1Upsell = false;
    let hasBonus2Upsell = false;

    let blockBonus1Code = false;
    let blockBonus2Code = false;

    cart.items.forEach(function (item) {
      const handle = normalize(item.handle);

      if (BONUS_1_DISCOUNT_HANDLES.includes(handle)) {
        if (isDrawerUpsellLine(item, 'Bonus 1')) {
          hasBonus1Upsell = true;
        } else {
          blockBonus1Code = true;
        }
      }

      if (BONUS_2_DISCOUNT_HANDLES.includes(handle)) {
        if (isDrawerUpsellLine(item, 'Bonus 2')) {
          hasBonus2Upsell = true;
        } else {
          blockBonus2Code = true;
        }
      }
    });

    const codes = [];

    /*
      Safe-zone logic:
      If the same discount-eligible product exists as a normal product-page item,
      do NOT apply that tier code. Shopify native discount codes cannot target
      only the drawer-added line when the product is also already in cart normally.
    */
    if (hasBonus1Upsell && !blockBonus1Code) {
      codes.push(DISCOUNT_CODES.bonus1);
    }

    if (hasBonus2Upsell && !blockBonus2Code) {
      codes.push(DISCOUNT_CODES.bonus2);
    }

    return codes;
  }

  async function getDiscountRedirectUrl(defaultRedirectPath) {
    const cart = await getCart();
    const codes = getDiscountCodesFromCart(cart);

    return buildDiscountUrl(codes, defaultRedirectPath);
  }

  function renderCart(cart) {
    lastCart = cart;

    cartCountEls.forEach(function (el) {
      el.textContent = cart.item_count + ' Items';
    });

    if (footerCountEl) {
      footerCountEl.textContent = cart.item_count + ' Items';
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (cartItemsContainer) {
      if (!cart.items.length) {
        cartItemsContainer.innerHTML = `
          <div class="ps-empty-cart">
            <p>Your cart is empty.</p>
          </div>
        `;
      } else {
        cartItemsContainer.innerHTML = cart.items
          .map(function (item) {
            const img = item.image ? item.image : '';

            return `
              <div class="ps-cart-item" data-line-key="${item.key}">
                <div class="ps-cart-item__image">
                  ${img ? `<img src="${img}" alt="${item.product_title}">` : ''}
                </div>

                <div class="ps-cart-item__content">
                  <h3 class="ps-cart-item__title">${item.product_title}</h3>

                  <div class="ps-cart-item__meta">
                    ${getItemOptions(item)}
                  </div>

                  <div class="ps-cart-item__actions">
                    <div class="ps-cart-qty">
                      <button type="button" data-ps-line-minus>−</button>
                      <input type="number" value="${item.quantity}" min="1" data-ps-line-qty>
                      <button type="button" data-ps-line-plus>+</button>
                    </div>

                    <button type="button" class="ps-cart-remove" data-ps-line-remove>
                      Remove
                    </button>
                  </div>
                </div>

                <div class="ps-cart-item__price">
                  ${formatMoney(item.final_line_price)}
                </div>
              </div>
            `;
          })
          .join('');
      }
    }

    updateFlowUI(cart);
  }

  async function refreshCart(openAfterRefresh) {
    const cart = await getCart();
    renderCart(cart);

    if (openAfterRefresh) {
      openDrawer();
    }

    return cart;
  }

  async function changeLine(lineKey, quantity) {
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    const cart = await res.json();
    renderCart(cart);
  }

  function createAddToCartFormData(variantId, quantity, properties) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity || 1);

    if (properties) {
      Object.keys(properties).forEach(function (key) {
        formData.append('properties[' + key + ']', properties[key]);
      });
    }

    return formData;
  }

  async function addVariantToCart(variantId, quantity, properties) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: createAddToCartFormData(variantId, quantity, properties)
    });

    if (!res.ok) {
      throw new Error('Add to cart failed');
    }

    return await refreshCart(true);
  }

  document.addEventListener('click', async function (event) {
    const closeBtn = event.target.closest('[data-ps-cart-close]');
    if (closeBtn) {
      closeDrawer();
      return;
    }

    const cartLink = event.target.closest('a[href="/cart"], a[href*="/cart"]');
    if (cartLink && !cartLink.href.includes('/checkout')) {
      event.preventDefault();
      await refreshCart(true);
      return;
    }

    const minusBtn = event.target.closest('[data-ps-line-minus]');
    if (minusBtn) {
      const item = minusBtn.closest('.ps-cart-item');
      const input = item.querySelector('[data-ps-line-qty]');
      const lineKey = item.getAttribute('data-line-key');
      const newQty = Math.max(1, parseInt(input.value, 10) - 1);

      await changeLine(lineKey, newQty);
      return;
    }

    const plusBtn = event.target.closest('[data-ps-line-plus]');
    if (plusBtn) {
      const item = plusBtn.closest('.ps-cart-item');
      const input = item.querySelector('[data-ps-line-qty]');
      const lineKey = item.getAttribute('data-line-key');
      const newQty = parseInt(input.value, 10) + 1;

      await changeLine(lineKey, newQty);
      return;
    }

    const removeBtn = event.target.closest('[data-ps-line-remove]');
    if (removeBtn) {
      const item = removeBtn.closest('.ps-cart-item');
      const lineKey = item.getAttribute('data-line-key');

      await changeLine(lineKey, 0);
      return;
    }

    const upsellMinus = event.target.closest('[data-ps-upsell-minus]');
    if (upsellMinus) {
      const card = upsellMinus.closest('.ps-upsell-card');
      const input = card.querySelector('.ps-upsell-qty input');
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      return;
    }

    const upsellPlus = event.target.closest('[data-ps-upsell-plus]');
    if (upsellPlus) {
      const card = upsellPlus.closest('.ps-upsell-card');
      const input = card.querySelector('.ps-upsell-qty input');
      input.value = parseInt(input.value, 10) + 1;
      return;
    }

    const declineBtn = event.target.closest('[data-ps-decline]');
    if (declineBtn) {
      hideFlowError();
      completeBonusStep(declineBtn.dataset.bonusStep);
      return;
    }

    const upsellAdd = event.target.closest('[data-ps-upsell-add]');
    if (upsellAdd) {
      const card = upsellAdd.closest('.ps-upsell-card');
      const variantSelect = card.querySelector('.ps-upsell-variant');
      const qtyInput = card.querySelector('.ps-upsell-qty input');

      const variantId = variantSelect.value;
      const qty = parseInt(qtyInput.value, 10) || 1;
      const step = upsellAdd.dataset.bonusStep;
      const tier = upsellAdd.dataset.bonusTier || (step === '2' ? 'Bonus 2' : 'Bonus 1');

      upsellAdd.disabled = true;
      upsellAdd.textContent = 'ADDING...';

      try {
        await addVariantToCart(variantId, qty, {
          '_ps_upsell_source': 'cart_drawer',
          '_ps_bonus_tier': tier,
          '_ps_discount_percent': upsellAdd.dataset.discount
        });

        hideFlowError();
        completeBonusStep(step);
        upsellAdd.textContent = 'ADDED';

        setTimeout(function () {
          upsellAdd.textContent = 'ADD TO CART';
          upsellAdd.disabled = false;
        }, 900);
      } catch (err) {
        console.error(err);

        upsellAdd.textContent = 'ERROR';

        setTimeout(function () {
          upsellAdd.textContent = 'ADD TO CART';
          upsellAdd.disabled = false;
        }, 1200);
      }

      return;
    }

    const checkoutBtn = event.target.closest('[data-ps-checkout]');
    if (checkoutBtn) {
      const cart = lastCart || await getCart();
      const flow = getFlowStateForCart(cart);

      if (!flow.hasCartItems) {
        showFlowError('Your cart is empty. Please add a product before checkout.');
        return;
      }

      if (!flow.bonus1Done) {
        showFlowError('Please add or decline the Bonus 1 offer before moving to Bonus 2.');
        if (bonus1Section) bonus1Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (!flow.bonus2Done) {
        showFlowError('Please add or decline the Bonus 2 offer before checkout.');
        if (bonus2Section) bonus2Section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const selected = document.querySelector('input[name="ps_decorate_choice"]:checked');

      if (!selected) {
        hideFlowError();
        if (decorateError) decorateError.style.display = 'block';
        return;
      }

      if (decorateError) decorateError.style.display = 'none';
      hideFlowError();

      const decorateValue = selected.value;

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'PROCESSING...';

      try {
        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            note: 'Want to be decorated?: ' + decorateValue,
            attributes: {
              'Want to be decorated?': decorateValue
            }
          })
        });

        if (decorateValue === 'Yes') {
          const redirectUrl = await getDiscountRedirectUrl(PURCHASE_PROCESS_URL);
          window.location.href = redirectUrl;
          return;
        }

        const redirectUrl = await getDiscountRedirectUrl(CHECKOUT_URL);
        window.location.href = redirectUrl;
      } catch (err) {
        console.error(err);

        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'CHECKOUT';
      }
    }
  });

  document.addEventListener('change', async function (event) {
    const qtyInput = event.target.closest('[data-ps-line-qty]');
    if (qtyInput) {
      const item = qtyInput.closest('.ps-cart-item');
      const lineKey = item.getAttribute('data-line-key');
      const newQty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

      await changeLine(lineKey, newQty);
    }

    const decorateRadio = event.target.closest('input[name="ps_decorate_choice"]');
    if (decorateRadio && decorateError) {
      decorateError.style.display = 'none';
    }
  });

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);

        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        });

        if (!res.ok) {
          throw new Error('Product add failed');
        }

        await refreshCart(true);
      } catch (err) {
        console.error(err);
        window.location.href = buildStorePath('/cart');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      }
    },
    true
  );

  refreshCart(false);
})();


